export const PAGE_TITLE = 'Plataforma de Gestión Minera de la Provincia de Buenos Aires';
